export enum SsoAttribute {
	EmployeeId = 1,
	EmailAddress = 2,
}
